export function createStaticUrl(manifest, base) {
    const root = (base ?? process.env.NEXT_PUBLIC_STATIC_BASE_URL ?? '').replace(/\/+$/, '');
    return function staticUrl(path) {
        if (!root || /^(https?:)?\/\//.test(path) || path.startsWith('data:'))
            return path;
        const key = manifest[path.startsWith('/') ? path : `/${path}`];
        // Not published (yet) → the app's own origin still has the file.
        return key ? `${root}/${key}` : path;
    };
}
